import { useT } from '@transifex/react'
import {
  hasContactInfo,
  isInvalidEmail,
} from '../../../common/customer-contact-utils'
import { STEPS } from '../types'
import type { Step2Props } from './Step2'

const shouldDisableNext = (props: Step2Props) => {
  return (
    Boolean(!props.selectedCustomer) ||
    !hasContactInfo(props.selectedCustomer) ||
    isInvalidEmail(props.selectedCustomer)
  )
}

export const useStep2Model = (props: Step2Props) => {
  const t = useT()

  return {
    backLabel: t('Back', {
      _context: 'Mark as unfulfilled modal - back button',
    }),
    customerLabel: t('Customer', {
      _context: 'Mark as unfulfilled modal - customer label',
    }),
    description: t(
      'Add a customer to record their contact information for the fulfillment.',
      {
        _context: 'Mark as unfulfilled modal header description',
      }
    ),
    handleBack: () => props.onStepChange(STEPS.METHOD),
    handleNext: () => props.onStepChange(STEPS.DETAILS),
    isNextDisabled: shouldDisableNext(props),
    nextLabel: t('Next', {
      _context: 'Mark as unfulfilled modal - next button',
    }),
    searchPlaceholder: t('Select or add a customer', {
      _context: 'Placeholder for customer search in unfulfilled modal',
    }),
    searchValue: props.newCustomer?.firstName || undefined,
    title: t('Add customer for the fulfillment', {
      _context: 'Mark as unfulfilled modal header',
    }),
  }
}
